import WithRender from "../../templates/ui/inputQuantity.html";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";

export default WithRender({
  computed: {
    ...mapGetters([
      "getQuantitiesValues",
      "getInputQuantityMinMax",
      "getPackingUnit",
      "getSweetAlert"
    ]),
    name: () => {
      return "Custom quantity:";
    }
  },
  methods: {
    ...mapActions(["setCustomQuantity"]),
    onQuantityEnter: function (event) {
      event.preventDefault();
      if (this.getQuantitiesValues.includes(this.quantity)) {
        this.getSweetAlert({
          text: i18n.t("Quantity already exists !"),
          icon: "warning"
        });
        return;
      }

      var isNum = /^\d+$/.test(this.quantity);
      if (!isNum) {
        this.getSweetAlert({
          text: i18n.t("Please enter a valid number !"),
          icon: "warning"
        });
        return;
      }

      var intQty = parseInt(this.quantity);

      var minMax = this.getInputQuantityMinMax;
      if (minMax.min && minMax.min > intQty) {
        this.getSweetAlert({
          text: i18n.t("Quantity should be bigger than or equal to {min}", {
            min: minMax.min
          }),
          icon: "warning"
        });
        return;
      }
      if (minMax.max && minMax.max < intQty) {
        this.getSweetAlert({
          text: i18n.t("Quantity should be lower than or equal to {max}", {
            max: minMax.max
          }),
          icon: "warning"
        });
        return;
      }
      if (intQty == 0) {
        this.getSweetAlert({
          text: i18n.t("Quantity should be bigger than 0"),
          icon: "warning"
        });
        return;
      }
      if (intQty % this.getPackingUnit !== 0) {
        this.getSweetAlert({
          text: i18n.t("The quantity must divide by {packUnit}!", {
            packUnit: this.getPackingUnit
          }),
          icon: "warning"
        });
        return;
      }

      this.setCustomQuantity(intQty);
    }
  },
  data: function () {
    return {
      quantity: null
    };
  }
});
